export default "__VITE_ASSET__6a58b350__"